import styled from "styled-components"
import media from "styled-media-query"

import Img from "gatsby-image"

export const Wrapper = styled.header`
  display: flex;
  flex-direction: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: auto;
  padding: 5px;

  a:not(:last-child) {
    margin-right: 40px;
  }

  ${media.lessThan("530px")`
    flex-direction: column;
    a:not(:last-child) {
      margin: 0 0 18px;
    }
  `}
`

export const Logo = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  outline: none;
  box-shadow: 1px 1px 2px 0px #0001;
  cursor: pointer;
  transition: all 0.1s ease;

  &:hover {
    transform: translateY(-5px);
  }
`

export const LogoImg = styled(Img)`
  width: 170px;
  height: 140px;
  border-radius: 2px;

  ${media.greaterThan("1110px")`
    width: 155px;
    height: 140px;
  `}


  ${media.lessThan("medium")`
    width: 135px;
    height: 105px;
  `}

  ${media.lessThan("440px")`
    width: 120px;
    height: 105px;
  `}
`
